import $ from 'jQuery';
import Splide from '../../../js/development/libs/splide.min.js';

export default function() {

    $(function(){
    if(window.navigator.userAgent.match(/(MSIE|Trident)/)){
    $('body').addClass('ie');
    }else{
        var canvas = $("#wrapper-canvas").get(0);

    var dimensions = {
        width: $(window).width(),
        height: $(window).height()
    };

    Matter.use('matter-attractors');
    Matter.use('matter-wrap');

    function runMatter() {
        // module aliases
        var Engine = Matter.Engine,
            Events = Matter.Events,
            Runner = Matter.Runner,
            Render = Matter.Render,
            World = Matter.World,
            Body = Matter.Body,
            Mouse = Matter.Mouse,
            Common = Matter.Common,
            Composite = Matter.Composite,
            Composites = Matter.Composites,
            Bodies = Matter.Bodies;

        // create engine
        var engine = Engine.create();

        engine.world.gravity.y = 0
        engine.world.gravity.x = 0
        engine.world.gravity.scale = 0.1

        // create renderer
        var render = Render.create({
            element: canvas,
            engine: engine,
            options: {
                showVelocity: false,
                width: dimensions.width,
                height: dimensions.height,
                wireframes: false,
                background: false
            }
        });

        // create runner
        var runner = Runner.create();

        // Runner.run(runner, engine);
        // Render.run(render);

        // create demo scene
        var world = engine.world;
        world.gravity.scale = 0;

        // create a body with an attractor
        var attractiveBody = Bodies.circle(
            render.options.width / 4,
            render.options.height / 4,
            (Math.max(dimensions.width / 8, dimensions.height / 8)) / 2,
            {
                render: {
                    fillStyle: `rgb(240,240,240)`,
                    strokeStyle: `rgb(240,240,240)`,
                    lineWidth: 0
                },
                isStatic: true,
                plugin: {
                    attractors: [
                        function (bodyA, bodyB) {
                            return {
                                x: (bodyA.position.x - bodyB.position.x) * 1e-6,
                                y: (bodyA.position.y - bodyB.position.y) * 1e-6,
                            };
                        }
                    ]
                }
            });

        World.add(world, attractiveBody);

        // add some bodies that to be attracted
        for (var i = 0; i < 15; i += 1) {
            let x = Common.random(0, render.options.width);
            let y = Common.random(0, render.options.height);
            let s = Common.random() > 0.6 ? Common.random(10, 80) : Common.random(4, 60);
            let poligonNumber = Common.random(3, 6);
            var body = Bodies.polygon(
                x, y,
                poligonNumber,
                s,

                {
                    mass: s / 5,
                    friction: 0,
                    frictionAir: 0.02,
                    angle: Math.round(Math.random() * 360),
                    render: {
                        fillStyle: '#FFFFFF',
                        strokeStyle: `#DDDDDD`,
                        lineWidth: 2
                    }
                }
            );

            World.add(world, body);


            let r = Common.random(0, 1)
            var circle = Bodies.circle(x, y, Common.random(2, 8), {
                mass: 0.1,
                friction: 0,
                frictionAir: 0.01,
                render: {
                    fillStyle: r > 0.3 ? `#EA0D49` : `rgb(234,13,73)`,
                    strokeStyle: `#EA0D49`,
                    lineWidth: 2
                }
            });
            World.add(world, circle);

            var circle = Bodies.circle(x, y, Common.random(2, 20), {
                mass: 4,
                friction: 0,
                frictionAir: 0,
                render: {
                    fillStyle: r > 0.3 ? `#008CA5` : `rgb(240,240,240)`,
                    strokeStyle: `#008CA5`,
                    lineWidth: 4
                }
            });
            World.add(world, circle);

            var circle = Bodies.circle(x, y, Common.random(2, 30), {
                mass: 0.1,
                friction: 0.6,
                frictionAir: 0.8,
                render: {
                    fillStyle: `rgb(240,240,240)`,
                    strokeStyle: `#FFFFFF`,
                    lineWidth: 3
                }
            });
            World.add(world, circle);
        }

        // add mouse control
        var mouse = Mouse.create(render.canvas);

        Events.on(engine, 'afterUpdate', function () {
            if (!mouse.position.x) return;
            // smoothly move the attractor body towards the mouse
            Body.translate(attractiveBody, {
                x: (mouse.position.x - attractiveBody.position.x) * 0.12,
                y: (mouse.position.y - attractiveBody.position.y) * 0.12
            });
            mouse.element.removeEventListener("mousewheel", mouse.mousewheel);
            mouse.element.removeEventListener("DOMMouseScroll", mouse.mousewheel);
            mouse.element.removeEventListener('touchmove', mouse.mousewheel);
            mouse.element.removeEventListener('touchmove', mouse.mousemove);
            mouse.element.removeEventListener('touchstart', mouse.mousedown);
            mouse.element.removeEventListener('touchend', mouse.mouseup);
        });

        // return a context for MatterDemo to control
        let data = {
            engine: engine,
            runner: runner,
            render: render,
            canvas: render.canvas,
            stop: function () {
                Matter.Render.stop(render);
                Matter.Runner.stop(runner);
            },
            play: function () {
                Matter.Runner.run(runner, engine);
                Matter.Render.run(render);
            }
        };
        Matter.Runner.run(runner, engine);
        Matter.Render.run(render);
        return data;
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    function setWindowSize() {
        let dimensions = {};
        dimensions.width = $(window).width();
        dimensions.height = $(window).height();

        m.render.canvas.width = $(window).width();
        m.render.canvas.height = $(window).height();
        return dimensions;
    }

    let m = runMatter()
    setWindowSize()
    $(window).resize(debounce(setWindowSize, 250))
    }
    });

    $.ajaxSetup({ cache: false });
    var filter_values = {
    order:'desc',
    per_page: 20,
    };
    var app = new Vue({
        el: '#app',
    template: '#blog',
        methods: {
            submit: function submit(e) {
                this.$root.updateResults();
            },
            searchchange: function searchchange(e) {
                filter_values.search = e.target.value;
            },
        },
        components: {
            Dropdown: {
                template: '#dropdown',
                props: ['label', 'endpoint', 'onchange'],
                data: function data() {
                    return {
                        selected: '',
                        items: [{
                            id: '',
                            name: 'Select'
                        }]
                    };
                },
                mounted: function mounted() {
                    var _this = this;
                    $.get('/wp-json/wp/v2/' + _this.endpoint,{per_page:40}, function(response) {
                        console.log(this);
                        _this.items = response;
                        _this.items.unshift({
                            id: '',
                            name: 'Select'
                        });
                    });
                },
                methods: {
                    change: function change(e) {
                        filter_values[e.target.id] = e.target.value;
                    }
                }
            },
            Results: {
                template: '#results',
                props: ['endpoint'],
                data: function data() {
                    return {
                        posts: [],
                        currentPage: 1,
                        pages: [],
                        pageCount: 0
                    };
                },
                mounted: function mounted() {
                    var _this = this;
                    _this.get_data(_this);
                    this.$root.updateResults = function() {
                        _this.currentPage = 1;
                        _this.get_data(_this);
                    };
                },
                methods: {
                    get_data: function get_data(_this) {
                        $.ajax({
                            type: 'GET',
                            url: '/wp-json/wp/v2/' + _this.endpoint,
                            data: $.extend(filter_values,{page:_this.currentPage}),
                            success: function success(response, textStatus, request) {
                                _this.posts = response;
                                _this.pageCount = request.getResponseHeader('X-Wp-Totalpages'); // storing the value in state
                                _this.paginate();
                            }
                        });
                    },
                    paginate: function() {
                        var self = this,
                        page = self.currentPage;
                        for (var j = 0, i = page - 9, pages = []; i < page + 9; i++) {
                            pages[j++] = {
                                current: i == page,
                                page_number: i
                            };
                        }
                        self.pages = pages.filter(function(n) {
                            return n.page_number > 0 && n.page_number <= self.pageCount && (n.page_number > page - 5 && n
                                .page_number < page + 5 || n.page_number <= 9 && page <= 5 || n.page_number > self.pageCount -
                                9 && page > self.pageCount - 5);
                        });
                    },
                    navigate: function(page) {
                        this.currentPage = page;
                        this.get_data(this);
                        window.location= "#jump";
                    }
                }
            }
        }
    });

    $(document).ready(function(){
                var submitIcon = $('.searchbox-icon');
                var inputBox = $('.searchbox-input');
                var searchBox = $('.searchbox');
                var isOpen = false;
                submitIcon.click(function(){
                    if(isOpen == false){
                        searchBox.addClass('searchbox-open');
                        inputBox.focus();
                        isOpen = true;
                    } else {
                        searchBox.removeClass('searchbox-open');
                        inputBox.focusout();
                        isOpen = false;
                    }
                });
                submitIcon.mouseup(function(){
                        return false;
                    });
                searchBox.mouseup(function(){
                        return false;
                    });
                $(document).mouseup(function(){
                        if(isOpen == true){
                            $('.searchbox-icon').css('display','block');
                            submitIcon.click();
                        }
                    });
            });
                function buttonUp(){
                    var inputVal = $('.searchbox-input').val();
                    inputVal = $.trim(inputVal).length;
                    if( inputVal !== 0){
                        $('.searchbox-icon').css('display','none');
                    } else {
                        $('.searchbox-input').val('');
                        $('.searchbox-icon').css('display','flex');
                    }
                }

    // var rellax = new Rellax('.rellax');



    // nav

    $('.menu-btn').click(function() {
    $('.menu-main-navigation-container').addClass('active');
    $('.close').addClass('close-up');

    });

    $('.close').click(function() {
    $('.menu-main-navigation-container').removeClass('active');
    $(this).removeClass('close-up');
    $('.sub-menu').removeClass('sub-menu-active');

    });

    $(document).ready(function() {

    var eventPresent = false;
    if ($(window).width()<1039 && eventPresent == false)
    {
    $(".menu-item-has-children > a").unbind().click(function(event)
    {
    if($(this).next('.sub-menu').hasClass('sub-menu-active')) {
    $(this).next('.sub-menu').removeClass('sub-menu-active');
    } else {
    $(this).next('.sub-menu').addClass('sub-menu-active');
    }
    event.preventDefault();

    });
    eventPresent  = true;
    }
    else if ($(window).width()>=1040 && eventPresent == true) {
    $("body").addClass("mobileview");
    $(".menu-item-has-children > a").unbind();
    eventPresent = false;
    }

    $(window).resize(function() {
    // console.log("current width : ", $(window).width());

    if ($(window).width()<1039 && eventPresent == false)
    {
    $(".menu-item-has-children > a").unbind().click(function(event)
    {
    event.preventDefault();
    $(this).next('.sub-menu').addClass('sub-menu-active');

    });
    eventPresent  = true;
    }
    else if ($(window).width()>=1040 && eventPresent == true) {
    $("body").addClass("mobileview");
    $(".menu-item-has-children > a").unbind();
    eventPresent = false;
    }
    });
    });


	$('.splide').each((i, el) => {
		const slider = new Splide(el, {
			type: 'loop',
			perPage: 1,
			focus: '0', // ensures no 'peek' of the next slide
			gap: 0,
			padding: 0,
			trimSpace: false,
			breakpoints: {
				1024: {
					perPage: 1,
					focus: '0',
					padding: 0,
					gap: 0
				}
			}
		}).mount();

		$(el).data('slider', slider);
	});

    $('.splide__arrows').on('click', '.splide__arrow--prev', function(e){
    e.preventDefault();

    var splide = $(this).closest('.splide').data('slider');

    splide.go('-1');

    });

    $('.splide__arrows').on('click', '.splide__arrow--next', function(e){
    e.preventDefault();

    var splide = $(this).closest('.splide').data('slider');

    splide.go('+1');

    });

    $('.splide__arrows').on('click', '.play-pause', function(e){
    e.preventDefault();

    var splide = $(this).closest('.splide').data('slider');

    var Autoplay = splide.Components.Autoplay;
    var flag = 99;
        if ($(this).hasClass('play')) {
            $(this).removeClass('play').addClass('pause');
            Autoplay.play(flag);
            $(this).blur();
        } else {
            $(this).removeClass('pause').addClass('play');
            Autoplay.pause(flag);
        }

    });


    function marginRight() {
        var marginRight = parseInt(jQuery(".home-case-studies").css("marginRight"));

        jQuery(".line").css("margin-right", marginRight + 100);

    } marginRight();

    jQuery(window).resize(marginRight);

    // blog


    function marginLeft() {
        var marginLeft = parseInt(jQuery(".blog-hero").css("marginRight"));

        jQuery(".blog-line").css("margin-left", marginLeft + 30);

    } marginLeft();

    jQuery(window).resize(marginLeft);

    function listingsRight() {
        var listingsRight = parseInt(jQuery(".results").css("marginRight"));

        jQuery(".filters").css("margin-right", listingsRight + 30);

    } listingsRight();

    jQuery(window).resize(listingsRight);

    function listingsLeft() {
        var listingsLeft = parseInt(jQuery(".results").css("marginLeft"));

        jQuery(".filters-inner").css("margin-left", listingsLeft + 30);

    } listingsLeft();

    jQuery(window).resize(listingsLeft);

    // cta boxes

    function ctaLeft() {

        var ctaLeft = parseInt(jQuery(".l-container").css("marginLeft"));

        jQuery(".l-two-column-left .content").css("margin-left", ctaLeft + 30);
    } ctaLeft();

    jQuery(window).resize(ctaLeft);

    function ctaRight() {
        var ctaRight = parseInt(jQuery(".l-container").css("marginRight"));

        jQuery(".l-two-column-right .content").css("margin-right", ctaRight + 30);

    } ctaRight();

    jQuery(window).resize(ctaRight);

    //landing page

    function landingLeft() {
        var landingLeft = parseInt(jQuery(".l-container").css("marginLeft"));

        jQuery(".landing-page-intro").css("margin-left", landingLeft + 30);

    } landingLeft();

    jQuery(window).resize(landingLeft);

    function landingRight() {
        var landingRight = parseInt(jQuery(".l-container").css("marginRight"));

        jQuery(".landing-page-right-col-content").css("margin-right", landingRight + 30);

    } landingRight();

    jQuery(window).resize(landingRight);

    $(".back-to-top").click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("body").offset().top
        }, 2000);
    });

    //spotlight overlay height
        $( window ).on( "load", function() {
            // console.log( "window loaded" );
    function spotlightHeight() {
        var spotlightHeight = parseInt(jQuery(".employee-headshot").css("height"));

        jQuery(".employee-details-overlay").css("height", spotlightHeight + 20);

    } spotlightHeight();

    jQuery(window).resize(spotlightHeight);
    });

    $(".back-to-top").click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("body").offset().top
        }, 2000);
    });


    // form redirect
    if($('#content_form').val()) {
    $(window).on('load', function() {
    var form = $('#content_form + .gform_wrapper form');
        $(form).submit(function() {
            // e.preventDefault();//prevent the form from actually submitting
            window.location = $('#content_form').val();
        });
    });
    }

    if($('#lp_content_form').val()) {
    $(window).on('load', function() {
    var form = $('#lp_content_form + .download-form + .gform_wrapper form');
        $(form).submit(function() {
            e.preventDefault();//prevent the form from actually submitting
            window.location = $('#lp_content_form').val();
        });
    });
    }

}
